import React from 'react';
import {images} from "assets/img/common/common";
import {HeaderMobile} from "components/common/HeaderMobile";
import {app} from "app/app";

export default function UnsupportedBrowserConfigurationPage({children}) {
    return <div className="login">
        <HeaderMobile/>
        <div className="login-image">
        </div>
        <div className="login-content">
            <img className="logo" src={images.logo} alt={app.productName()}/>
            <h3>Tu navegador no está configurado correctamente</h3>
            {children}
        </div>
    </div>
}
